var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResistanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6607 2.66732C14.6607 1.93398 14.0673 1.33398 13.334 1.33398H2.66732C1.93398 1.33398 1.33398 1.93398 1.33398 2.66732V10.6673C1.33398 11.4007 1.93398 12.0007 2.66732 12.0007H12.0007L14.6673 14.6673L14.6607 2.66732ZM13.334 2.66732V11.4473L12.554 10.6673H2.66732V2.66732H13.334ZM12.0007 8.00065H4.00065V9.33398H12.0007V8.00065ZM4.00065 6.00065H12.0007V7.33398H4.00065V6.00065ZM12.0007 4.00065H4.00065V5.33398H12.0007V4.00065Z",
    fill: "#696F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResistanceIcon);
export default __webpack_public_path__ + "static/media/resistance_icon.d425d76471c85b1b4173064a5c22e1f6.svg";
export { ForwardRef as ReactComponent };